import React, { useEffect, useState } from 'react';
import './FetchPayments.css';
import { Helmet } from 'react-helmet';
import { getPaymentDetailsWithMobileNumber, getPaymentDetailsWithPaymentId } from '../Backend/firebase/payment';
import SearchPayments from './SearchPayments';


function FetchPayments() {
    const [records, setRecords] = useState([]);

    const loadPaymentsWithMobileNumber = async (mobileNumber) => {
        try {
            const getPayments = await getPaymentDetailsWithMobileNumber(mobileNumber);
            setRecords(getPayments)
        } catch(error) {
            console.log("Error Occur in Get Payments Records", error)
        }
    };

    const loadPaymentsWithPaymentId = async (paymentId) => {
        try {
            const getPayments = await getPaymentDetailsWithPaymentId(paymentId);
            setRecords(getPayments)
        } catch(error) {
            console.log("Error Occur in Get Payments Records", error)
        }
    };

    return (
        <>
            <div className="container-fluid">
                <Helmet>
                    <meta name="description" content="Search your dream product..." />
                    <title>Products | Kaipsool Pharmatech</title>
                </Helmet>
                <div className="row">
                    <div className="col-lg-8 col-md-8 col-sm-12 mx-auto mt-4">
                        <div className="products">
                            <div className="products__banner mt-5">
                                <SearchPayments loadPaymentsWithMobileNumber={loadPaymentsWithMobileNumber} loadPaymentsWithPaymentId={loadPaymentsWithPaymentId}  />
                            </div>
                            {records && records.length > 0 ? <div className="row products__banner products__contents">
                                {records.map((record) => {
                                    return (<div className="row">
                                        <div className="col-lg-12 col-md-12 col-sm-12 mx-auto mb-5">
                                            <div className="productDetail mt-5">
                                                <div className="row">
                                                    <div className="col-md-7">
                                                        <div className="productDetail__companyInfo">
                                                            {record?.events && <h5 className="MainColor">{record?.events?.tournamentName}</h5>}
                                                            <p className="productDetail__title">By {record?.events?.organizerName}</p>
                                                            <p className="productDetail__title">Location: {record?.events?.location}</p>
                                                            <p className="productDetail__title">Event Type: {record?.events?.eventCategory}</p>
                                                            <p className="productDetail__title">Start at <b>{record?.events?.startDate?.toDate()?.toDateString()}</b></p>
                                                            <p className="productDetail__title">Last Date of Registration: <b>{record?.events?.registrationClosingDate?.toDate()?.toDateString()}</b></p>
                                                            <hr />
                                                            {record?.name && <h5 className="MainColor">Name : {record?.name}</h5>}
                                                            {record?.phone && <p className="productDetail__title">Phone Number : {record?.phone}</p>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <div className="productDetail__companyInfo">
                                                            <div className="bookingDetail__companyInfo">
                                                                <div className="pricing__box">
                                                                    <p className="leftText"> Total Tickets </p>
                                                                    <p className="rightText"> <b>{record?.tickets.length > 0 ? record?.tickets.length : 0} </b></p>
                                                                </div>
                                                                <hr className="hr__sports" />
                                                                {record?.tickets.length > 0 && <>
                                                                    {record?.tickets.map((tickets, index) => {
                                                                        return <div className="pricing__box" key={index}>
                                                                            <p className="leftText"> {tickets.entryCategory} </p>
                                                                            <p className="rightText"> <b>{tickets.ticketCount}* Rs. {tickets.entryFees}</b> </p>
                                                                        </div>
                                                                    })}
                                                                    </>
                                                                }
                                                            </div>
                                                            <div className="pricing__box total__amount">
                                                                <p className="leftText"> Total Amount </p>
                                                                <p className="rightText"> Rs. {record?.tickets.length > 0 ? (record?.amount / 100) : 0} </p>
                                                            </div>
                                                            {record?.paymentStatus === "Captured" ? <div className="pricing__box total__amount sucess">
                                                                <p className="leftText"> Status </p>
                                                                <p className="rightText"> <b>Paid</b> </p>
                                                            </div> : <div className="pricing__box total__amount failed">
                                                                <p className="leftText"> Status </p>
                                                                <p className="rightText"> <b>Failed</b> </p>
                                                            </div>}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>);
                                })}
                                <div className="col-md-2 mt-2"></div>
                            </div> : <div className="notFound">
                                <div className="text-center mt-3">
                                    <span style={{ fontWeight: '500', fontSize: '18px' }}>No Payments Found. Please Enter Payment ID or Mobile Number.</span>
                                </div> 
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default FetchPayments
